import React from 'react'
import Layout from '../../../components/layouts/Layout'
import './style/fullscreenview.css'
const FullScreenView = () => {
    return (
        <Layout className="layout_padding_margin_off">
           <div className="d-flex full_screen_area">
               <div className="main_screen w-75 bg-dark">
                    
                        Hello
               </div>
               <div className="sidebar w-25 bg-success">
                    
                        Hello bang
               </div>
           </div>
        </Layout>
    )
}

export default FullScreenView
